import { action } from 'typesafe-actions';
import { OptionMenuActions, OptionsMenuActionsName } from './types';
import { MarkSchemeFile } from './reducer';

export const onMenuItemClick = (activeItem: string) => action(OptionMenuActions.ON_MENU_ITEM_CLICK, activeItem);

export const onToggleConfirmModal = (activeItem: string) => action(OptionMenuActions.ON_TOGGLE_CONFIRM_MODAL, activeItem);

export const onCloseOptionsMenu = () => action(OptionMenuActions.CLOSE_OPTIONS_MENU);

export const onOpenOptionsMenu = () => action(OptionMenuActions.OPEN_OPTIONS_MENU);

export const fileIsReadyForDownload = () => action(OptionMenuActions.ON_FILE_IS_READY_FOR_DOWNLOAD);

export const apiCallIsFinished = () => action(OptionMenuActions.API_CALL_IS_FINISHED);

export const onDownloadApiCall = () => action(OptionMenuActions.CALL_DOWNLOAD_FILE_API);

export const onFileReadyForUpload = (file: File, actionName: OptionsMenuActionsName) => {
    return action(OptionMenuActions.ON_FILE_IS_READY_FOR_UPLOAD, { file, actionName });
};

export const onFileIsUploaded = () => action(OptionMenuActions.ON_FILE_IS_UPLOADED);

export const onGradeIsUpdated = () => action(OptionMenuActions.ON_UPDATED_GRADE);
export const onMarkIsUpdated = () => action(OptionMenuActions.ON_UPDATED_MARK);

export const onCancelAction = () => action(OptionMenuActions.ON_CANCEL_ACTION);

export const onMarkSchemeFileUploaded = (payload: MarkSchemeFile) => action(OptionMenuActions.ON_MARK_SCHEME_FILE_UPLOADED, payload);
export const resetMarkSchemeFileUpload = () => action(OptionMenuActions.RESET_MARK_SCHEME_FILE_UPLOADED);
